module.exports = __webpack_public_path__ + "img/homew.ad40e864.png";